import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSanMarino = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_2125)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0.521719 12 12 10.4348 12 10.4348L24 12Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.7632 8.28021L12 13.0435L7.23671 8.28021C6.62072 9.1946 6.26086 10.2952 6.26086 11.4783V13.0435C6.26086 15.5567 7.88485 17.6976 10.1385 18.4725C9.83766 19.062 9.88838 19.7977 10.3291 20.3478C10.9145 19.8786 11.5206 19.393 12.0347 18.981C12.5488 19.393 13.1549 19.8787 13.7402 20.3478C14.1862 19.7913 14.2332 19.0446 13.9206 18.4516C16.1434 17.6599 17.7391 15.5347 17.7391 13.0435V11.4783C17.7391 10.2952 17.3792 9.19465 16.7632 8.28021Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 17.2174C9.69842 17.2174 7.82605 15.3449 7.82605 13.0435V11.4783C7.82605 9.17676 9.69847 7.30438 11.9999 7.30438C14.3014 7.30438 16.1738 9.1768 16.1738 11.4783V13.0435C16.1738 15.3449 14.3015 17.2174 11.9999 17.2174Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 13.0435V11.4783C14.6087 10.0398 13.4385 8.86957 12 8.86957C10.5616 8.86957 9.39136 10.0398 9.39136 11.4783V13.0435L12 13.5652L14.6087 13.0435Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39136 13.0435C9.39136 14.4819 10.5616 15.6521 12 15.6521C13.4385 15.6521 14.6087 14.4819 14.6087 13.0435H9.39136Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 7.30433C15.1305 6.43991 14.4297 5.73913 13.5653 5.73913C13.1643 5.73913 12.7988 5.89007 12.5218 6.13799V5.21736H13.0435V4.17388H12.5218V3.65216H11.4783V4.17388H10.9566V5.21736H11.4783V6.13799C11.2013 5.89007 10.8358 5.73913 10.4348 5.73913C9.57041 5.73913 8.86963 6.43991 8.86963 7.30433C8.86963 7.76779 9.07124 8.18404 9.39135 8.47068V9.3913H14.6087V8.47068C14.9289 8.18404 15.1305 7.76779 15.1305 7.30433Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_2125",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSanMarino;
